import { useState } from "react";
import { IconButton, Tooltip, Stack } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

/**
 * An icon button that asks for inline confirmation before firing — the trigger
 * icon swaps to a confirm (✓) / cancel (✕) pair on click (MD3 icon buttons with
 * tooltips + aria-labels for accessibility). Used for destructive row actions
 * where a full dialog would be heavy.
 */
export default function IconConfirmButton({
  icon = <DeleteOutlineIcon fontSize="small" />,
  tooltip,
  confirmTooltip = "Confirm",
  cancelTooltip = "Cancel",
  onConfirm,
  color = "error",
  disabled = false,
  buttonTestId,
  confirmTestId,
  cancelTestId,
}) {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <Stack direction="row" spacing={0.5} justifyContent="center">
        <Tooltip title={confirmTooltip}>
          <IconButton
            size="small"
            color={color}
            aria-label={confirmTooltip}
            data-testid={confirmTestId}
            onClick={() => {
              setConfirming(false);
              onConfirm?.();
            }}
          >
            <CheckIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={cancelTooltip}>
          <IconButton
            size="small"
            aria-label={cancelTooltip}
            data-testid={cancelTestId}
            onClick={() => setConfirming(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size="small"
          color={color}
          aria-label={tooltip}
          disabled={disabled}
          data-testid={buttonTestId}
          onClick={() => setConfirming(true)}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
}
